$(document).ready(function () {
    require('./chat/chat').init();
});
